// extracted by mini-css-extract-plugin
export default {"container":"CopyInput_container__YUxCq","row":"CopyInput_row__tcCUj","copy":"CopyInput_copy__XVkG2","icon":"CopyInput_icon__E51Op"};